import React, { useRef, useState } from "react";
import profilePic from '../../../../assets/png/default_profile.png';
import DetailIcon from '../../../../assets/svg_main/detailed-icon.svg';
import { dateFormate } from "@constants/index";
import { desiredFormatDate } from "@utils/commonUtils";
import useNavigateWithMenuItem from "@components/common/CustomHooks/useNavigateWithMenuItem";
import { useDispatch } from "react-redux";
import { setBeneficiaryImage, updateChild } from "@store/actions/beneficiaryAction";

const ChildListCard = ({ child, index, childCount }: any) => {
    const [hovered, setHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const inputRef = useRef<any>(null);
    const navigateWithMenuItem = useNavigateWithMenuItem();
    const dispatch = useDispatch();

    const handleClick = () => {
        setShowModal(true);
        inputRef.current?.click();
    };
    const abbreviateName = (fullName: string): string => {
        const nameParts = fullName.split(' ');
        if (nameParts.length > 1) {
            return `${nameParts[0]} ${nameParts[1][0]}.`;
        }
        return fullName;
    }
    const handleChildClick = ()=>{
        dispatch(updateChild('throughParentProfile', true));
        dispatch(setBeneficiaryImage({}));
        navigateWithMenuItem(`/beneficiaries/view/${child?.child_benef_id}`);
    }

    return (
        <div className="child-list-card" data-testid={`child-card-${index}`} style={{ borderLeft: `4px solid ${child.child_gender === "Male" ? "#BECCE5" : "#E6BEDE"}` }}
            onClick={handleChildClick}>
            <div className="img-name-container" style={{ width: "10%" }}>
                <div
                    className="child-image"
                    onMouseOver={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                <img
                    src={child.img_url ? child.img_url : profilePic}
                    alt="Profile Image"
                />                    
                </div>

                <div className="name-container">
                    {abbreviateName(child.child_name)}
                </div>
            </div>
            <div className="dob-container child-list-card-middle-item" > {desiredFormatDate(child?.dob, dateFormate["dd/mm/yyy"])}</div>
            <div className="child-list-card-middle-item" >{child.child_gender}</div>
            <div className="bal-abha-id-container child-list-card-middle-item" >{child.bal_abha_id}</div>
            <div className="child-list-card-middle-item" style={{ width:"7%", backgroundColor: "#E2ECF1" }}>Child {childCount - index}</div>
            <div style={{ width: "6%", textAlign: "end" }}><DetailIcon /></div>
        </div>
    )
}

export default React.memo(ChildListCard);
